<template>
  <div>
    <b-loading v-model="isLoading"></b-loading>
    <b-sidebar
      type="is-light"
      :fullheight="isFullheight"
      :overlay="isOverlay"
      :right="isRight"
      :open.sync="open"
      :on-cancel="closeSideBar"
      style="width: 400px"
      v-if="testData"
      :can-cancel="['escape', 'x']"
    >
      <div class="retake-sidebar-wrapper">
        <div class="retake-content">
          <div class="p-0 form">
            <div class="columns is-multiline">
              <div class="column is-10 border-bottom">
                <h1 class="form-title">{{ testData.title }}</h1>
              </div>
              <div class="column is-2 border-bottom">
                <b-button
                  class="button-close-top"
                  style="float:right"
                  @click="closeSideBar()"
                >
                  Close
                </b-button>
              </div>
              <div class="column is-12">
                <p>
                  Pilih Subtest yang ingin Anda
                  <i>re-take</i>
                  :
                </p>
              </div>
              <div class="column is-12">
                <table class="table is-fullwidth subtest-table">
                  <thead>
                    <tr>
                      <!-- SELECT ALL -->
                      <th width="30">
                        <b-checkbox
                          v-model="isSelectAll"
                          @input="toggleAllSubtest"
                          type="is-hcc"
                        />
                      </th>

                      <th>Subtest</th>
                      <th>Completed</th>
                      <th>Submitted At</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(section, index) in subtest" :key="index">
                      <td>
                        <b-checkbox
                          v-model="section.isRetake"
                          type="is-hcc"
                          @input="syncSelectAll"
                        />
                      </td>

                      <td>{{ section.title }}</td>

                      <td>
                        <span
                          :class="
                            section.completed
                              ? 'has-text-success'
                              : 'has-text-grey'
                          "
                        >
                          {{ section.completed ? 'Yes' : 'No' }}
                        </span>
                      </td>

                      <td>
                        {{ section.submitted_at || '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="retake-warning-box">
                  <b-switch
                    v-model="deleteAnswered"
                    type="is-danger"
                    size="is-small"
                  />

                  <p class="retake-warning-text">
                    Hapus jawaban dari soal-soal yang telah dijawab oleh peserta
                    pada subtest yang dipilih.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="retake-sidebar-footer">
          <b-button type="is-light" @click="closeSideBar()">
            Batal
          </b-button>

          <b-button type="is-hcc" @click="submitRetake">
            Retake
          </b-button>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'retake-assessment',
  props: {
    isOpen: Boolean,
    testData: Object,
  },
  data() {
    return {
      isLoading: false,
      open: this.isOpen,
      subtest: [],
      isFullheight: true,
      isOverlay: true,
      isSelectAll: false,
      deleteAnswered: false,
      isRight: true,
      searchTags: [],
      isFetching: false,
      isFetchingCategory: false,
    }
  },
  async created() {
    const response = await this.fetchDataSubtest(this.testData)
    this.subtest = response.data.assessment.newSection.map(section => ({
      id: section.id,
      title: section.title,
      completed: response.data.sections.some(
        s => s.newSectionId === section.id && s.isConfirm == 1
      ),
      submitted_at: response.data.sections.find(
        s => s.newSectionId === section.id && s.isConfirm == 1
      )?.updatedAt,
      isRetake: false,
    }))
  },
  methods: {
    ...mapActions({
      fetchDataSubtest: 'fetchDataSubtest',
    }),

    toggleAllSubtest() {
      this.subtest.forEach(section => {
        section.isRetake = this.isSelectAll
      })
    },

    submitRetake() {
      const selectedSubtestIds = this.subtest
        .filter(section => section.isRetake)
        .map(section => section.id)

      this.$emit('submit-retake', {
        subtestIds: selectedSubtestIds,
        uid: this.testData.newUserId,
        newAssessmentId: this.testData.newAssessmentId,
        deleteAnswered: this.deleteAnswered,
      })
      this.closeSideBar()
    },

    syncSelectAll() {
      this.isSelectAll = this.subtest.every(section => section.isRetake)
    },

    closeSideBar() {
      this.$emit('close', false)
      this.open = false
    },
  },
  computed: {
    ...mapGetters({}),
  },
  watch: {
    isOpen() {
      this.open = this.isOpen
    },
  },
}
</script>
<style lang="scss">
.b-sidebar .sidebar-content.is-fixed.is-right {
  width: 60% !important;
  padding-right: 10.5px;
  border: 1px solid whitesmoke;
}

.form {
  padding-left: 10px !important;

  &-title {
    color: #000000 !important;
    font-size: 24px !important;
    font-weight: 900 !important;
  }
}

.retake-warning-box {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding: 12px 16px;
  background: #fff8e1;
  border: 1px solid #f0d58c;
  border-radius: 8px;
  font-size: 14px;
}

.retake-warning-text {
  color: #333;
  font-weight: 500;
}

.retake-sidebar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.retake-content {
  flex: 1;
  overflow-y: auto;
}

.retake-sidebar-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  position: sticky;
  bottom: 0;
  z-index: 10;
}
</style>
